export const thousandsGroupStyleTypes = {
	thousand: 'thousand',
	lakh: 'lakh',
	wan: 'wan',
};
